import { CstCustPIIEntityIdDto } from "./cust-pii_id-dto";

export class CustPiiDto {
    // panNumber: string;
    // aadhar: string;
    // doctype:string;
    cstCustPii : CstCustPIIEntityIdDto;
    docKey:string = '';

    constructor(){
        this.cstCustPii = new CstCustPIIEntityIdDto();
    }
}
